import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import { Row,  Table } from 'reactstrap';

import { useNavigate } from 'react-router-dom';
import { BiEditAlt, BiTrash } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom'
import { BiLeftArrowAlt } from 'react-icons/bi';
import useAuth from '../../hooks/useAuth';
import { CommunityFeatPaginationTable } from '../../components/PaginationC/CommunityFeatPaginationTable';

const CommunityFeatureView = () => {
    const { auth } = useAuth();

    const [modal, openModal] = useState(false);
    const toggle = () => openModal(!modal);
    const [communityFeatures, setCommunityFeatures] = useState([]);
    const navigate = useNavigate();

    const handleDelete =  async (event, id) => {
        event.preventDefault();
        try {
            const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/community-features/delete/${id}`,  {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            });
            const res1 = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/community-features/find-all`);
            setCommunityFeatures(res1.data);
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
        } catch (error) {
            error.response.data.message ? toast.error(error.response.data.message, {
                className: "error-toast",
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
                }) :  toast.error(error.response.data.error, {
                  className: "error-toast",
                  position: toast.POSITION.BOTTOM_RIGHT,
                  autoClose: 3000
              })
         }
    }
        
   
    useEffect(() => {
      const source = axios.CancelToken.source();
      const getcommunityFeatures = async () => {
      try {
          const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/community-features/find-all`, {
              cancelToken: source.token
          });
          setCommunityFeatures(res.data);
         
      } catch (error) {
              if (axios.isCancel(error)) {
                  console.log('cancelled');
              } else {
                  throw error;
              }
          }
      }
      
      getcommunityFeatures();
      return () => {
          source.cancel();
      };
  },[])
    return (
        <div className="container">
          <Row sm="12">
            <h5 className="sec-header">Community Features Information</h5>
        </Row> 
        <Row>
        <CommunityFeatPaginationTable data={communityFeatures} />
            {/* <Table responsive hover>
                <thead>
                <tr>
                    <th>#</th>
                    <th>Feature Name</th>
                    <th>Feature Description</th>
                 
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {
                    communityFeatures.map(cf => (
                      <tr key={cf.id}>
                            <td>{cf.id}</td>
                            <td style={{wordBreak: "break-all"}}>{cf.featureName}</td>
                            <td style={{wordBreak: "break-all"}}>{cf.featureDesc}</td>
                           
                            <td>
                                <BiEditAlt className="edit_icon icon_hover" onClick={() => navigate(`/community/feature/edit/${cf.id}`)} size={20}/> 
                                <BiTrash className="delete_icon icon_hover" onClick={(event) => handleDelete(event, cf.id)} size={20} />     
                            </td>
                    </tr>
                  ))  
                }
                                
                </tbody>
            </Table> */}
     </Row>
     {
        communityFeatures && <Row sm="12" className="mt-4 text-center">
          <Link to={"/community/feature/add"} className="go_back" >
            <BiLeftArrowAlt size={30} /> Go to Add Community Feature
          </Link>
      </Row> 
         }
        </div>
    )
   
}

export default CommunityFeatureView;